import React from "react"
import { Card, CardBody, Row, Col } from "reactstrap"
import ThemePlaceholder from "components/Common/ThemePlaceholder"

const ProfileSkeleton = () => {
  return (
    <Card className="shadow-sm border-0 rounded-lg">
      <CardBody className="p-4">
        {/* Header Skeleton */}
        <Row className="align-items-center mb-4 pb-3 border-bottom">
          <Col xs="auto">
            <ThemePlaceholder height={50} width={50} style={{ borderRadius: "50%" }} />
          </Col>
          <Col>
            <ThemePlaceholder height={20} width="60%" className="mb-2" />
            <ThemePlaceholder height={14} width="40%" className="mb-1" />
            <ThemePlaceholder height={18} width="30%" />
          </Col>
        </Row>

        {/* Info Skeleton */}
        <Row className="g-3">
          {[...Array(5)].map((_, index) => (
            <Col xs={12} sm={6} key={index}>
              <div className="d-flex align-items-start">
                <ThemePlaceholder height={20} width={20} className="me-2 mt-1" />
                <div style={{ flex: 1 }}>
                  <ThemePlaceholder height={12} width="40%" className="mb-1" />
                  <ThemePlaceholder height={16} width="80%" />
                </div>
              </div>
            </Col>
          ))}
          <Col xs={12}>
            <div className="d-flex align-items-start pt-2 border-top">
              <ThemePlaceholder height={20} width={20} className="me-2 mt-1" />
              <div style={{ flex: 1 }}>
                <ThemePlaceholder height={12} width="30%" className="mb-1" />
                <ThemePlaceholder height={16} width="50%" className="mb-1" />
                <ThemePlaceholder height={12} width="40%" />
              </div>
            </div>
          </Col>
        </Row>
      </CardBody>
    </Card>
  )
}

export default ProfileSkeleton
